export enum TipoClienteEnum {
  CONCESSIONARIA = "CONCESSIONARIA",
  DESPACHANTE = "DESPACHANTE",
  PARTICULAR = "PARTICULAR",
  LOJISTA = "LOJISTA",
}
